<template>
<div>
  <div v-if="jobseekerProfile">
    <div v-for="(item, index) in items" :key="index">
      <div v-if="item.description !== ''">
        <item  :title="item.title" :description="item.description" :is-compact="true" />
        <divider />
      </div>
    </div>
  </div>
  <item :title="this.$t('jobs.resume')">
  <p v-if="resumeFile === 'attached'">{{this.$t('jobs.attached')}}</p>
  <p v-else-if="resumeFile">{{this.resumeStatus}} • <a :href="resumeUrl" target="_blank">{{this.$t('jobs.view')}}</a> • <a @click="toggleDeleteModal" class="delete-text">{{this.$t('signup.delete')}}</a></p>
  <p v-else>{{this.resumeStatus}}</p>
  </item>
  <div v-if="jobseekerProfile">
    <divider />
    <div>
      <item  :title="this.$t('profile.jobsBoard') + ':'" :is-compact="true" />
      <div v-if="jobBoards.length > 0" v-for="jobBoard in jobBoards" :key="jobBoard.id" class="job-board-list-container">
        <img :src="jobSeekerImage(jobBoard.id,jobBoard.image)" class="mr-2" alt="" width="24" height="24"> <p>{{jobBoard.name}}</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Item from '@/components/general/sidebar-section'
import Divider from '@/components/general/divider'
import _ from 'lodash'

export default {
  components: { Item, Divider },
  props: {
    isOther: {
      type: Boolean,
      default: false
    },
    toggleResumeModal: {
      type: Function
    }
  },
  computed: {
    ...mapState('jobseekerProfiles', [
      'jobseekerProfile'
    ]),
    ...mapGetters('jobseekerProfiles', [
      'resumeStatus'
    ]),
    ...mapGetters('users', [
      'user'
    ]),
    jobBoards () {
      if (this.jobseekerProfile && this.jobseekerProfile.hasOwnProperty('talentPools')) {
        return this.jobseekerProfile.talentPools
      }
      return []
    },
    salary () {
      return this.jobseekerProfile.salary
    },
    noticePeriodInDays () {
      return this.jobseekerProfile.noticePeriod
    },
    noticePeriodText () {
      return this.noticePeriodInDays ? `${this.noticePeriodInDays} days` : ''
    },
    items () {
      const salaryText = this.salary
        ? `$${this.salary.toLocaleString()} (min)` : ''
      const locations = this.jobseekerProfile.locations
      if (this.jobseekerProfile.isRemoteAvailable) {
        locations.unshift('Remote')
      }
      return [{
        title: this.$t('jobs.roles'),
        description: this.jobseekerProfile.roles.join(', ')
      }, {
        title: this.$t('jobs.salary'),
        description: salaryText
      }, {
        title: this.$t('jobs.locations'),
        description: locations.join(', ')
      }, {
        title: this.$t('jobs.contractTypes'),
        description: this.jobseekerProfile.contracts.map(_.capitalize).join(', ')
      }, {
        title: this.$t('jobs.noticePeriod'),
        description: this.noticePeriodText
      }]
    },
    resumeUrl () {
      return this.jobseekerProfile.resumeUrl
    },
    resumeFile () {
      if (this.resumeStatus === 'Unattached') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    toggleDeleteModal () {
      this.toggleResumeModal()
    },
    jobSeekerImage (boardId, imageUrl) {
      return imageUrl || `/api/identicons/${boardId}`
    },
    getDescription (description) {
      if (description !== '') {
        return description
      } else {
        return `${this.user.lastName} hasn't shared this yet`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item h6.heading {
  margin-bottom: 0.5rem;
}

.job-board-list-container{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.mr-2{
  margin-right: 12px;
}
.delete-text{
  color: #E25862
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/preferences.vue